import { createStore } from 'zustand'

import { offset } from '../utils/offset'

import { ContextMenuStore } from './interface'

const DEFAULT_OFFSET = [10, 10]

export const createContextMenuStore = <T>() =>
  createStore<ContextMenuStore<T>>((set, get) => ({
    visible: false,
    style: undefined,
    context: undefined,
    offset: undefined,
    close() {
      set({ visible: false, context: undefined })
      get().onClose?.()
      setTimeout(() => {
        set({ style: undefined })
      }, 300)
    },
    open({ x, y }, context) {
      const { offset: offsetValue = DEFAULT_OFFSET } = get()
      set({
        context,
        visible: true,
        style: {
          top: offset(y, offsetValue[0]),
          left: offset(x, offsetValue[1])
        }
      })
      get().onOpen?.(context)
    }
  }))
